<template>
<div class="p-5 arkaplan">
<img src="https://www.goodencenter.org/wp-content/uploads/2019/02/bigstock-223855057.jpg" class="resim" />
<div class="row p-5 m-5">
  <div class="col-sm-6 col-md-6 col-lg-6">
    <div class="card">
      <div class="card-body text-center">
        <h5 class="card-title">Kablosuz Beyin'e Hoşgeldiniz!</h5>
        <p class="card-text">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quae reiciendis blanditiis at vel cupiditate illum molestias, magnam, voluptas nisi inventore impedit officia. Mollitia ut aliquam esse voluptatibus, debitis et nisi. Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam consectetur odio possimus ex obcaecati laboriosam blanditiis sequi doloribus fugiat ipsam quaerat, magni tenetur adipisci iste. Eaque illo culpa quod. Iusto. Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti, deleniti! Dignissimos vitae, cum ullam praesentium labore iste reprehenderit, illum molestias incidunt possimus voluptate asperiores tempore omnis recusandae laboriosam, facere delectus?</p>
        <a href="#hakkimizda" class="btn btn-primary">Hakkımızda</a>
      </div>
    </div>
  </div>
  <div class="col-sm-6">
    <div>
      <div class="text-center mt-5">
        <img src="../assets/brain.png" class="brain mt-5" />
      </div>
    </div>
  </div>
</div>
  </div>
</template>
<script>
export default {};
</script>

<style scoped>
.arkaplan {
    position: relative;
    overflow: hidden;
    padding: 16px;
    height: 660px;
}
.resim {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: auto;
    opacity: 0.6;
}
.brain {
  width: 250px;
  height: 250px;
  opacity: 1;
}
</style>
